module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrese3e"
    }
  }, [_vm._v("\n  Online Test Backend\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b7e9874!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrese3e/component.vue
// module id = 3797
// module chunks = 1